import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Utility function for handling async operations with error handling
export const handleAsync = async (asyncFn, errorMessage = "An error occurred") => {
  try {
    return await asyncFn();
  } catch (error) {
    console.error(errorMessage, error);
    throw error;
  }
};

// Utility function for formatting dates
export const formatDate = (date, options = {}) => {
  if (!date) return 'N/A';
  
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  try {
    return new Date(date).toLocaleString('en-US', { ...defaultOptions, ...options });
  } catch (e) {
    return 'Invalid Date';
  }
};

// Utility function for truncating text
export const truncateText = (text, maxLength = 100) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};
